<template>
  <div>
    <v-row lign="center" justify="center">
      <v-col>
        <newCategory v-model:categoryid="editCategory"></newCategory>
      </v-col>
      <v-col>
        <log v-if="$model.isAdmin" target="documents" objecttable="psm_document_category,psm_document_variables"
          class="inline pointer d-flex justify-end">
        </log>
      </v-col>
    </v-row>

    <template v-if="elements !== null">
      <v-row>
        <v-col cols="12" md="6" lg="4" xl="3" v-for="category in elements" :key="category.id"
          @contextmenu="showContext($event, category.id, category.countDoc)"
          :class="category.settings.hide && !$model.isAdmin ? 'd-none' : ''">
          <router-link :to="{ path: '../orders/' + category.id }">
            <v-row>
              <v-col align-self="center" class="pa-0" cols="2"><img :src="$model.img_folder + '/blue-folder.png'" /></v-col>
              <v-col align-self="center" class="pa-0"><span :class="category.settings.hide && $model.isAdmin ? 'text-red-lighten-1' : ''">{{
                  category.name }}</span></v-col>
            </v-row>
          </router-link>
        </v-col>
      </v-row>

    </template>
    <template v-else>
      <v-skeleton-loader type="article"></v-skeleton-loader>
    </template>

    <v-menu v-model="context.show" :target="[context.x, context.y]" absolute offset-y>
      <v-list>
        <v-list-item @click="edit(context.categoryid)">
          <v-list-item-title>Редактировать</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="context.canDelete" @click="deleteCat(context.categoryid)">
          <v-list-item-title>Удалить</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import "../styles.css"
import newCategory from "./new-category.vue";
import log from "moodleDir/procollege/lib/vue/log.vue";
export default {
  components: {
    newCategory,
    log,
  },
  data() {
    return {
      elements: null,
      editCategory: false,
      context: {
        show: false,
        x: 0,
        y: 0,
        categoryid: 0,
        canDelete: false
      },
    };
  },
  created() {
    this.axios
      .post(
        this.$model.wwwroot + "/procollege/manage_groups/documents3/categoriesGetCrumbs",
        new URLSearchParams({
          catalogid: this.$route.params.id,
        })
      )
      .then((response) => {
        this.$eventBus.$emit("set-crumbs", response.data);
      })
      .catch((error) => {
        this.axiosDefaultErrorHandler(error);
      });
    this.getCategories();

    this.$eventBus.$on("categories-reload-documents", (hideDialog) => {
      if (hideDialog) {
        this.editCategory = false;
      }
      this.getCategories();
    });

  },
  beforeUnmount() {
    this.$eventBus.$off("categories-reload-documents");
  },
  methods: {
    getCategories() {
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/documents3/categoriesGetList",
          new URLSearchParams({
            catalogid: this.$route.params.id,
          })
        )
        .then((response) => {
          this.elements = response.data;
        })
        .catch((error) => {
          this.axiosDefaultErrorHandler(error);
        });
    },
    edit(categoryid) {
      this.editCategory = categoryid;
    },
    deleteCat(categoryid) {
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/documents3/categoriesDelete",
          new URLSearchParams({
            categoryid: categoryid,
          })
        )
        .then((response) => {
          this.elements = response.data;
        })
        .catch((error) => {
          this.axiosDefaultErrorHandler(error);
        });
    },
    showContext(e, categoryid, countDoc) {
      if (this.$model.isAdmin) {
        e.preventDefault();
        this.context.show = false;
        this.context.x = e.clientX;
        this.context.y = e.clientY;
        this.context.categoryid = categoryid;
        this.context.canDelete = parseInt(countDoc) == 0 ? true : false;
        this.$nextTick(() => {
          this.context.show = true;
        });
      }
    },
  },
};
</script>